<template>
  <div id="pie-chart"></div>
</template>

<script>
import c3 from 'c3';
import 'c3/c3.min.css';
import csv from '@/csv';
import { CHART_COLORS } from '@/settings';

export default {
  name: 'Pie',

  data() {
    return {
      chart: null,
      data: [],
      type: 'percent',
      resizeListener: () => {
        const newSize = {
          width: document.querySelector('.chart-info-container').offsetWidth,
          height: document.querySelector('.chart-info-container').offsetHeight,
        };

        this.chart.resize(newSize);
      },
    };
  },

  props: {
    id: {
      required: true,
    },
    variable: {
      type: String,
      required: true,
    },
    classCol: {
      type: String,
      required: true,
    },
    valueCol: {
      type: String,
      required: true,
    },
    range: {
      type: String,
      default: 'all',
    },
  },

  mounted() {
    fetch(`data/${this.id}/${this.variable}.csv`)
      .then(response => response.text())
      .then((text) => {
        this.data = csv(text, ['total']);

        this.chart = c3.generate({
          bindto: '#pie-chart',
          size: {
            width: document.querySelector('.chart-info-container').offsetWidth,
            height: document.querySelector('.chart-info-container').offsetHeight,
          },
          data: {
            type: 'pie',
            json: this.classes,
            colors: CHART_COLORS,
          },
          tooltip: {
            format: {
              value(value, ratio) {
                const r = (ratio * 100).toFixed(2);

                return `${r}%`;
              },
            },
          },
        });

        window.addEventListener('resize', this.resizeListener, { passive: true });
      });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeListener, { passive: true });
  },

  computed: {
    classes() {
      const obj = {};

      this.data.filter((i) => {
        if (this.range === 'all') {
          return true;
        }

        return this.range === i.range;
      }).forEach((i) => {
        if (Object.hasOwnProperty.call(obj, i[this.classCol])) {
          obj[i[this.classCol]] += i[this.valueCol];
        } else {
          obj[i[this.classCol]] = i[this.valueCol];
        }
      });

      return obj;
    },
  },

  watch: {
    variable() {
      this.refetch();
    },

    id() {
      this.refetch();
    },

    range() {
      this.chart.load({
        json: this.classes,
        unload: true,
      });
    },
  },

  methods: {
    refetch() {
      fetch(`data/${this.id}/${this.variable}.csv`)
        .then(response => response.text())
        .then((text) => {
          this.data = csv(text, ['total']);

          this.chart.load({
            json: this.classes,
            unload: true,
          });
        });
    },
  },
};
</script>
